import validator from "validator";
import uniqid from 'uniqid';
import ReactHtmlParser from 'react-html-parser';
import { startsWith } from 'lodash';
import {extractSnippet, formatEmojis, highlightQuery} from './various';

const DELETED_MESSAGE = 'Deleted message';

export const boldText = (text:string) => {
  if (!text) {
    return '';
  }
  const regex = /\*(.*?)\*/g;
  return text.replace(regex, (match:any) => {
    return `<strong>${match}</strong>`
  });
}

export const getUserName = (userId: any, members: any) => {
  let username = '';
  if (!members || !members.length || !userId) {
    return username;
  }

  const foundUser = members.find((member:any) => member.user_id === userId);
  if (!foundUser) {
    return username;
  }
  username = foundUser.real_name;
  if (foundUser.deleted) {
    username = `${username} (deactivated)`
  }
  return username;
}

export const replaceUsernames = (text:string, users:any) => {
  if (!text) {
    return '';
  }
  const regex = /<@(.*?)>/g;
  return text.replace(regex, (match:any) => {
    const slimM = match.replace('<@', '').replace('>', '');
    let userName = getUserName(slimM, users);

    return `<span key="${uniqid()}" style="color:#007bff">${userName || 'Deactivated User'}</span>`
  });
}

export const formatChannelNames = (text:string, channels: any, highlight:string[]) => {
  if (!text) {
    return ''
  }
  const regex = /<#(.*?)>/g;
  return text.replace(regex, (match: any, p1) => {
    let txt = p1;
    if (txt.indexOf('|') > -1) {
      txt = txt.split('|')[1];
    } else {
      const ch = channels.find((c:any) => c.conversation_id === txt);
      if (ch) {
        txt = ch.channel_name;
      }
    }
    if (highlight.indexOf(txt) > -1) {
      return `<span style="font-weight: 600; color: #EF1C62">#${txt}</span>`
    }
    return `<span key="${uniqid()}" style="color:#007bff">#${txt}</span>`;
  });
}

export const beautifyLinks = (text: string, highlight:string[]) => {
  const pattern = /<(.*?)>/g;
  return text.replace(pattern, (match, p1) => {
    const url = match.replace('<', '').replace('>', '');
    let urlText = highlightQuery(url, highlight);
    if (validator.isEmail(url)) {
      return `<a key="${uniqid()}" href="mailto:${url}" target="_blank" rel="noopener noreferrer">
                ${urlText}
              </a>`
    }
    if (url.indexOf('|') > -1) {
      const [linkUrl, urlText] = url.split('|');
      if (startsWith(linkUrl, 'mailto:')) {
        return `<a key="${uniqid()}" href="${linkUrl}" target="_blank" rel="noopener noreferrer">
                ${highlightQuery(urlText, highlight)}
              </a>`
      }
      if (validator.isURL(linkUrl)) {
        const trimTxt = highlightQuery(urlText, highlight)
        return `<a key="${uniqid()}" href="${linkUrl}" target="_blank" rel="noopener noreferrer">
                ${trimTxt}
              </a>`
      }
    }

    if (validator.isURL(url)) {
      return `<a key="${uniqid()}" href="${url}" target="_blank" rel="noopener noreferrer">
                ${urlText}
              </a>`
    }

    return match;
  });
};

export const formatCode = (text:string) => {
  const codeRx = /```([^`]*)```/g;
  const newTxt = text.replace(codeRx, (match, p1) => {
    return `<p class="code-preview">${p1}</p>`
  })
  return newTxt;
}

// This needs to be moved to process block elements from slack
export const formatSlackResult = (text:string, users:any, channels:any, currentChannel:string, highlight:string[]) => {
  if (!text) {
    return {
      text: DELETED_MESSAGE,
      snippet: DELETED_MESSAGE,
    };
  }
  let linkedText = beautifyLinks(text, highlight);
  linkedText = formatCode(linkedText);
  linkedText = formatEmojis(linkedText);
  linkedText = boldText(linkedText);
  let newText:string[] = linkedText.split(/\*?`?(<[^>]*>)`?\*?/g);
  newText = newText.map((part: string, i: number) => {
    const firstChars = part.slice(0, 2);
    if (firstChars === '<@') {
      return replaceUsernames(part, users);
    }
    if (firstChars === '<#') {
      return formatChannelNames(part, channels, highlight);
    }
    if (firstChars === '<!') {
      const chName = currentChannel || part.substring(2, part.length - 1);
      return `<span key="${uniqid()}" style="color:#007bff">@${chName}</span>`
    }
    return part;
  });
  const textMsg = newText.join(' ');
  return {
    text: ReactHtmlParser(textMsg),
    snippet: ReactHtmlParser(extractSnippet(textMsg)),
  }
}

export const getSlackMessageAttachments = (message:any) => {
  const { files } = message;
  if (!files || !files.length) {
    return [];
  }
  return files.map((file: any) => {
    let url = file.public_url_shared ? file.permalink_public : file.url_private;
    return {
      filename: file.name || 'File was deleted',
      mimeType: file.mimetype,
      content: '',
      url,
    }
  })
}
/*

export const processSlackMessage = (message: any, users:any, highlight:string[]) => {
  if (!message.blocks || !message.blocks.length) {
    //return formatSlackResult(message.text, users, highlight);
  }
  const { blocks } = message;
  const messageBlocks = blocks.map((block:any) => {
    const { elements } = block;
    return elements.map((element:any) => {

    })
  })
}*/
